import { authFetch } from "./authFetch";

async function handle(res, errorMessage) {
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || errorMessage);
    }
    return res.json();
}

export const getTradingData = async () => {
    const res = await authFetch("/api/trading");
    return handle(res, "Помилка завантаження даних");
};

export const updateTradingDeposit = async (deposit) => {
    const res = await authFetch("/api/trading/settings", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deposit }),
    });
    return handle(res, "Помилка оновлення балансу");
};

export const updateTradingBaseAmount = async (baseAmount) => {
    const res = await authFetch("/api/trading/settings", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ baseAmount }),
    });
    return handle(res, "Помилка оновлення базової ставки");
};

export const createTradingPair = async (symbol) => {
    const res = await authFetch("/api/trading/pairs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ symbol }),
    });
    return handle(res, "Помилка створення пари");
};

export const deleteTradingPair = async (pairId) => {
    const res = await authFetch(`/api/trading/pairs/${pairId}`, { method: "DELETE" });
    return handle(res, "Помилка видалення пари");
};

export const createTradingBet = async (pairId, payload) => {
    const res = await authFetch(`/api/trading/pairs/${pairId}/bets`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    return handle(res, "Помилка створення ставки");
};

export const updateTradingBet = async (betId, payload) => {
    const res = await authFetch(`/api/trading/bets/${betId}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    return handle(res, "Помилка оновлення ставки");
};

export const deleteTradingBet = async (betId) => {
    const res = await authFetch(`/api/trading/bets/${betId}`, { method: "DELETE" });
    return handle(res, "Помилка видалення ставки");
};

export const uploadBetScreenshot = async (betId, imageBase64) => {
    const res = await authFetch(`/api/trading/bets/${betId}/screenshots`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ imageBase64 }),
    });
    return handle(res, "Помилка завантаження скріншота");
};

export const deleteBetScreenshot = async (betId, screenshotId) => {
    const res = await authFetch(`/api/trading/bets/${betId}/screenshots/${screenshotId}`, {
        method: "DELETE",
    });
    return handle(res, "Помилка видалення скріншота");
};
